import { LOCALES } from '../../locales';
import { generalFormI18n } from '../shared/form.i18n';

export default {
  [LOCALES.ENG]: {
    ...generalFormI18n[LOCALES.ENG],
    
    app_gallety_all_apps: 'All Apps ({uploaded_apps} out of {total_apps})',
    //application filters
    app_gallery_categories: 'Categories',
    app_gallery_types: 'Types',
    app_gallery_products: 'Products',
    //header
    app_gallery_dev_portal: 'Dev Portal',
    app_gallery_app_gallery: 'AppGallery',
    //btn
    app_gallety_load_apps: 'Load More Apps (+{load_more_apps})',
    app_gallery_more_information: 'More Information',
    app_gallery_add_app: 'Add App',
    app_gallery_launch: 'Launch',
    app_gallery_remove_app: 'Remove App',
    app_gallery_lunch_app: 'Launch App',
    //app description
    app_gallety_by: 'by',
    app_gallery_updated: 'Updated',
    app_gallety_request_info: 'Request Info',
    app_gallety_overview: 'Overview',
    app_gallety_documentation: 'Documentation',
    app_gallety_dev_details: 'Dev Details',
    app_gallery_back_to_apps: 'Back to Apps',
    app_gallery_read_more: 'Read more',
    app_gallery_show_less: 'Show less',
    app_gallery_not_found_page: 'Not Found Page',
    app_gallery_main_title: 'Explore Apps from our Partners',
    app_gallery_added: 'Added',
    //footer
    app_gallery_footer: '© {value} All rights reserved. Greenway Health, LLC',
    developer_landing_footer_terms_of_service: 'Terms of Service',
    developer_landing_footer_privacy_policy: 'Privacy Policy',

    // application tabs content
    // documentation
    app_gallery_tab_doc_details_content_title: 'Tutorials and Documentation',
    app_gallery_tab_doc_details_content_subtitle_license:
      'EULA (End User License Agreements) ',
    app_gallery_country: 'Country',
    app_gallery_website: 'Website',
    app_gallery_company_name: 'Company Name',
    app_gallery_city: 'City',
    app_gallery_state: 'State',
    app_gallery_post_code: 'Postal Code',
    app_gallery_description: 'Description',
    app_gallery_facing: 'Audience',
    app_gallery_provider:'Provider',
    app_gallery_patient:'Patient'
  },
};
